import React, { ReactElement } from "react";

import styles from "./sidebarnavcard.module.scss";
import { Card } from "react-bootstrap";

import SidebarMenuItem from "../models/SidebarMenuItem";
import SidebarMenuItemType from "../enums/SidebarMenuItemType";

import SidebarNavLink from "./SidebarNavLink";
import SidebarAccordionCard from "./SidebarAccordionCard";
import { useTranslation } from "react-i18next";
import RolesChecker from "features/customer/components/RolesChecker";

interface IProps {
  menuItem: SidebarMenuItem,
  activeCardId: string
}

const SidebarNavCard: React.FC<IProps> = (props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  const {menuItem, activeCardId} = props;

  const menuType = (menuItem: SidebarMenuItem): ReactElement | undefined => {
    switch (menuItem.type) {
      case SidebarMenuItemType.Heading:
        return (
          <h6 className={styles.sidebarSectionTitle}>
            {tLabels(`sidebarNavCard.headings.${menuItem.title}`)}
          </h6>
        );
      case SidebarMenuItemType.Route:
      case SidebarMenuItemType.Link:
      case SidebarMenuItemType.DynamicLink: 
        return <SidebarNavLink menuItem={menuItem}  />
      default:
        return <SidebarAccordionCard menuItem={menuItem} activeCardId={activeCardId} />
    }    
  };

  if (menuItem.visibleForRole) {
    return (
      <RolesChecker enabledRoles={menuItem.visibleForRole}>
        <Card className={styles.sidebarCard}>
          {menuType(menuItem)}
        </Card>
      </RolesChecker>
    );
  } else {
    return (
      <Card className={styles.sidebarCard}>
        {menuType(menuItem)}
      </Card>
    );
  }
};

export default SidebarNavCard;